// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606120913/js/" + chunkId + "." + {"44":"eea11c1a","225":"77cafa16","481":"a132ab96","486":"dca79c92","770":"be76e5c8"}[chunkId] + ".0.9543362240392335.chunk.js";
};